import axios from '@/server/axios'

export function queryParkStyle(type) {
  return axios({
    url: 'officialWebsite/listByGarden.do',
    method: 'get',
    params: {
     type
    }
  })
}